import { Theme } from 'src/types/Theme';

export const PLICK_THEME: Theme = {
  colors: {
    primary: '#253746',
    primaryDark: '#111A22',
    primaryLight: '#3D5A73',
    primaryFaded: '#B7C9D8',
    secondary: '#4298B5',
    secondaryDark: '#2D6F86',
    secondaryLight: '#57BDE3',
    secondaryFaded: '#D0F2FF',
    complementary: '#EDF5F7',
    surface: '#ADB6B9',
    surfaceDark: '#575757',
    surfaceLight: '#BFD3D9',
    surfaceFaded: '#E5ECEE',
    light: '#FFFEFC',
    dark: '#222424',
    danger: '#FF3939',
    dangerDark: '#E01818',
    dangerLight: '#FE7A7A',
    dangerFaded: '#FFD8D8',
    success: '#04AF00',
    successDark: '#037E00',
    successLight: '#6EFE6B',
    successFaded: '#D1FFD0',
    accent: '#08C380',
    accentDark: '#059360',
    accentLight: '#36EDAB',
    accentFaded: '#CBFFEC',
    warning: '#FEAE33',
    warningDark: '#FD9900',
    warningLight: '#F9C87C',
    warningFaded: '#FFF3E0',
    info: '#00B7C2',
    infoDark: '#007F87',
    infoLight: '#44E7F1',
    infoFaded: '#CCFCFF',
    help: '#995ED6',
    helpDark: '#5D4DBA',
    helpLight: '#C593F9',
    helpFaded: '#ECDDFC',
    textBase: '#253746',
    textDisclaimer: '#253746',
    textLight: '#FFFEFC',
    textFaded: '#E5ECEE',
  },
};
